import type { GeneralParameters } from '../../general/parameters/general'
import type { FavoriteAddParameters } from '../parameters/favorite-add'

import { Analytix } from '~/shared/analytix'
import { AnalytixEvent } from '../../general/event'
import { Gate, seeds } from '../../general/gate'
import { parameters } from '../parameters/favorite-add'

/**
 * Event wrapper for `favorite_add`.
 * Uses session gate to prevent pre-session delivery.
 */
export class FavoriteAddEvent extends AnalytixEvent<FavoriteAddParameters> {
  name = 'favorite_add'
  group = 'favorite'
  parameters = parameters
  sender = Analytix.prototype.sendFavoriteAddEvent

  // `favorite_add` event uses session gate to ensure that it is not emitted before session is started
  gates = [Gate.Uses(seeds.session)]

  constructor() {
    super()
    this.verify()
  }

  validate(): false | [GeneralParameters, FavoriteAddParameters] {
    return [
      Object.fromEntries(this.general),
      Object.fromEntries(this.parameters),
    ]
  }
}
